import { engineComponent, NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { WinAnimator } from "../WinAnimator";
import { FreespinsController } from "./FreespinsController";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { DataManager } from "../../Managers/DataManager";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { BaseView } from "../Base/BaseView";
import { ImageTextCounterElement } from "../../Components/Elements/Texts/ImageTextCounterElement";
import { AmbientBackground } from "../../Utils/AmbientBackground";
import { MachineExtended } from "../../CustomComponents/MachineExtended";
import { PaylinesExtended } from "../../CustomComponents/PaylinesExtended";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";
import { WinAnimatorExtendedFS } from "../../CustomComponents/WinAnimatorExtendedFS";
import { AppContext } from "../../../Common/AppContext";
import { BetManager } from "../../Managers/BetManager";
import { GroupTweens } from "../../CustomComponents/GroupTweens";
import { TimelineElement } from "../../Components/Elements/Graphics/TimelineElement";

@engineComponent(ComponentTypes.DisplayObject)
export class FreespinsView extends LayoutContainerElement {
    static FsMessageBoxRetrigger: TimelineElement;
    static FsMessageBoxTotal: TimelineElement;

    private _controller: FreespinsController;
    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;
    private _machineStoppedDelay: FrameTimerEventEmitter;
    private _fsMessageVisibleTimer: FrameTimerEventEmitter;
    private _paylines: PaylinesExtended;
    private _symbols: Symbols;
    private _machine: MachineExtended;
    private _winAnimator: WinAnimatorExtendedFS;
    private _groupTweens: SwitchElement;
    private _wasOutroFsMessageBoxRetrigger: boolean = false;

    // private _fsMessageStart: HTMLElement;
    // private _fsMessageEnd: HTMLElement;
    // private _fsMessageEndNoWin: HTMLElement;

    constructor() {
        super();
        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));
        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));
        this._machineStoppedDelay = CreateFrameTimer("machineStoppedDelay");
        this._machineStoppedDelay.on(FrameTimerEvents.Complete, this.machineStoppedDelayed.bind(this));
        this._fsMessageVisibleTimer = CreateFrameTimer("fsMessageVisibleTimer");
        this._fsMessageVisibleTimer.on(FrameTimerEvents.Complete, function () {
            FreespinsView.FsMessageBoxRetrigger.visible = false;
        });
    }

    public create(node: Element): void {
        super.create(node);
        if (this.childs["Symbols"] != null) {
            this._symbols = this.childs["Symbols"];
            this.removeChild(this._symbols);
        }
        if (this.childs["Paylines"] != null) this._paylines = this.childs["Paylines"];
        if (this.childs["Machine"] != null) this._machine = this.childs["Machine"];
        if (this.childs["WinAnimator"] != null) this._winAnimator = this.childs["WinAnimator"];
        if (this.childs["GroupTweens"] != null) this._groupTweens = this.childs["GroupTweens"];
        if (this.childs["FsMessageBoxRetrigger"] != null)
            FreespinsView.FsMessageBoxRetrigger = this.childs["FsMessageBoxRetrigger"];
        if (this.childs["FsMessageBoxTotal"] != null)
            FreespinsView.FsMessageBoxTotal = this.childs["FsMessageBoxTotal"];

        if (FreespinsView.FsMessageBoxRetrigger) {
            FreespinsView.FsMessageBoxRetrigger.visible = false;
        }

        if (FreespinsView.FsMessageBoxTotal) {
            FreespinsView.FsMessageBoxTotal.visible = false;
        }

        // set childs to GroupTweens object
        if (this._groupTweens) {
            let groupTweenElements: Object = this._groupTweens.getChildElements();
            if (groupTweenElements) {
                for (let key in groupTweenElements) {
                    if (groupTweenElements.hasOwnProperty(key)) {
                        if (groupTweenElements[key] instanceof GroupTweens) {
                            (<GroupTweens>groupTweenElements[key]).setChilds(this.childs);
                        }
                    }
                }
            }
        }

        // this._fsMessageStart = document.getElementById('fsMessageStart');
        // this._fsMessageEnd = document.getElementById('fsMessageEnd');
        // this._fsMessageEndNoWin = document.getElementById('fsMessageEndNoWin');
        //
        // //prevent first animation on page load
        // this._fsMessageStart.classList.add('_noAnim');
        // this._fsMessageEnd.classList.add('_noAnim');
        // this._fsMessageEndNoWin.classList.add('_noAnim');
    }

    public initReceived(controller: FreespinsController): void {
        this._controller = controller;
        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.freespinsResponse != null) {
                    if (
                        GameManager.freespinsResponse.initData != null &&
                        GameManager.freespinsResponse.initData.reels !== null
                    ) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(MachineExtended.RollFinished, this.rollFinished.bind(this));
                        this._machine.on(MachineExtended.OneReelRollFinished, this.oneReelRollFinished.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            GameManager.freespinsResponse.initData.reels,
                            this._winAnimator,
                            this.childs["Teasing"],
                            this.childs["NoTrimWinContainer"],
                        );
                    }

                    if (this._winAnimator != null) {
                        this._winAnimator.on(WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
                        this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                        this._winAnimator.initialize(
                            this._symbols,
                            this._paylines,
                            this.childs["PaylinesLines"],
                            this.childs["NoWinContainer"],
                            this.childs["WinContainer"],
                            this,
                        );
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no freespin reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.visible = false;
    }

    public startReceived(): void {
        // if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
        //     this._fsMessageStart.classList.add(HtmlController.DisabledClass);
        // }
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.reset(true);
    }

    public spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    public endReceived(): void {}

    public spin(): void {
        PlayList.loop("SND_FSLoop");
        // if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
        //     this._fsMessageStart.classList.add(HtmlController.DisabledClass);
        // }

        if (FreespinsView.FsMessageBoxRetrigger.visible == true && this._wasOutroFsMessageBoxRetrigger == false) {
            this._wasOutroFsMessageBoxRetrigger = true;

            FreespinsView.FsMessageBoxRetrigger.goToOutro();

            this._fsMessageVisibleTimer.stop();
            this._fsMessageVisibleTimer.start(60);
        }

        this._machine.spinStart(this._winAnimator.reset(true, true), true, this._winAnimator.currentSymbols);
    }

    public stop(): void {
        this._machine.spinStop(null, true);
    }

    public initIntro(): void {
        AmbientBackground.changeAmbientBackground("fs", 0);

        this._machine.setStoppedSymbolsArray(GameManager.freespinsResponse.screen.reels);
        this._winAnimator.showSymbols(GameManager.freespinsResponse.screen.reels);

        this._winAnimator.showInitWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin);
        this.visible = true;
        this.retrigger();

        if (this._groupTweens) {
            this._groupTweens.goToCase(GroupTweens.CaseInitIntro);
        }

        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSEndWait");
            PlayList.play("SND_FSEnd");

            if (FreespinsView.FsMessageBoxTotal != null) {
                FreespinsView.FsMessageBoxTotal.visible = true;
                FreespinsView.FsMessageBoxTotal.play(GameManager.freespinsResponse.totalWin, 0, 0);
            }
        } else {
            PlayList.loop("SND_FSLoop");
        }
    }

    public intro(long: boolean = false): void {
        if (this._groupTweens) {
            this._groupTweens.goToCase(GroupTweens.CaseBaseToFreespins);
        }

        this.alpha = 1;
        this.visible = true;

        this._introDelay.start(100);
    }

    private introFinished(): void {
        PlayList.loop("SND_FSLoop");
        this._controller.introFinished();
    }

    public outro(): void {
        this.visible = true;

        PlayList.stop("SND_FSLoop");
        PlayList.stop("SND_FSEndWait");
        PlayList.play("SND_FSTransOut");

        AmbientBackground.changeAmbientBackground("base", 60);

        this._winAnimator.reset(true);

        if (FreespinsView.FsMessageBoxTotal != null) {
            FreespinsView.FsMessageBoxTotal.visible = true;
            FreespinsView.FsMessageBoxTotal.goToOutro();
        }

        if (this._groupTweens) {
            this._groupTweens.goToCase(GroupTweens.CaseFreespinsToBase);
        }

        // if (this._fsMessageEnd != null && !this._fsMessageEnd.classList.contains(HtmlController.DisabledClass)) {
        //     this._fsMessageEnd.classList.add(HtmlController.DisabledClass);
        // }
        // if (this._fsMessageEndNoWin != null && !this._fsMessageEndNoWin.classList.contains(HtmlController.DisabledClass)) {
        //     this._fsMessageEndNoWin.classList.add(HtmlController.DisabledClass);
        // }
        this._outroDelay.start(60);
    }

    private outroFinished(): void {
        this.visible = false;

        if (FreespinsView.FsMessageBoxTotal != null) {
            FreespinsView.FsMessageBoxTotal.visible = false;
        }

        this._winAnimator.resetTimer();
        this._controller.outroFinished();
    }

    public disableLogo(): void {
        if (this.childs["Logo"] != null) {
            this.removeChild(this.childs["Logo"]);
        }
    }

    public enable(): void {
        PlayList.play("SND_FSWin");

        if (BaseView.FsMessageBox != null) {
            BaseView.FsMessageBox.visible = true;
            BaseView.FsMessageBox.play(12, 0, 30);
        }

        // if (this._fsMessageStart != null && this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
        //     this._fsMessageStart.classList.remove(HtmlController.DisabledClass);
        // }
    }

    private oneReelRollFinished(reelIndex: number): void {
        this._winAnimator.onOneReelRollFinished(reelIndex);
    }

    private rollFinished(): void {
        this._controller.rollFinished();
    }

    private onReelStopped(): void {
        this._winAnimator.onReelStopped(GameManager.freespinsResponse.screen.reels, this._machine.actualReelStopped);
    }

    private machineStopped(): void {
        // if (this._winAnimator.isWild) {
        //     this._machineStoppedDelay.stop();
        //     this._machineStoppedDelay.start(60);
        // } else {
        this.machineStoppedDelayed();
        // }
    }

    private machineStoppedDelayed(): void {
        this._controller.machineStopped();
        if (this._winAnimator.showWins(GameManager.freespinsResponse.wins, GameManager.freespinsResponse.currentWin)) {
            PlayList.stop("SND_FSLoop");
        }
        if (GameManager.freespinsResponse.currentWin === 0) {
            if (this.isLastFreespin()) {
                PlayList.stop("SND_FSLoop");
                PlayList.loop("SND_FSEndWait");
                PlayList.play("SND_FSEnd");

                if (FreespinsView.FsMessageBoxTotal != null) {
                    FreespinsView.FsMessageBoxTotal.visible = true;
                    FreespinsView.FsMessageBoxTotal.play(GameManager.freespinsResponse.totalWin, 0, 0);
                }
            }
        }
    }

    private finishQuickWinCalculation(): void {
        this._controller.quickWinCalculationFinished();
    }

    private finishWinCalculation(): void {
        this._controller.winCalculationFinished();
    }

    private finishWinAnimator(): void {
        this._controller.allWinsFinished();
        if (this.isLastFreespin()) {
            PlayList.stop("SND_FSLoop");
            PlayList.loop("SND_FSEndWait");
            PlayList.play("SND_FSEnd");

            if (FreespinsView.FsMessageBoxTotal != null) {
                FreespinsView.FsMessageBoxTotal.visible = true;
                FreespinsView.FsMessageBoxTotal.play(GameManager.freespinsResponse.totalWin, 0, 0);
            }
        } else {
            PlayList.loop("SND_FSLoop");
        }
        this.retrigger();
    }

    private retrigger(): void {
        if (!this.isLastFreespin()) {
            if (GameManager.freespinsResponse.wins != null && GameManager.freespinsResponse.wins.length > 0) {
                for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                    if (GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                        this._wasOutroFsMessageBoxRetrigger = false;
                        FreespinsView.FsMessageBoxRetrigger.visible = true;
                        FreespinsView.FsMessageBoxRetrigger.play(12, 12, 0);
                    }
                }
            }
        }
    }

    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }

        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        );
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Freespins/FreespinsView.ts
 **/